// extracted by mini-css-extract-plugin
export default {"roles-tag-text":"style_roles-tag-text__SkJpy","rolesTagText":"style_roles-tag-text__SkJpy"};